import { render, staticRenderFns } from "./PostBody.vue?vue&type=template&id=38af96a8&scoped=true&"
import script from "./PostBody.vue?vue&type=script&lang=ts&"
export * from "./PostBody.vue?vue&type=script&lang=ts&"
import style0 from "./PostBody.vue?vue&type=style&index=0&id=38af96a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af96a8",
  null
  
)

export default component.exports